import debounce from 'lodash/debounce';
import stickyNavTabs from 'helpers/stickyNavTabs';

export default () => {
  const therapistID = $('.js-therapist-id').val();
  const $calendarContainer = $('.js-calendar-container');
  const $hoursContainer = $('.js-hour-availabilities-container');
  const $dateField = $('.js-booking-date-field');
  const $hourField = $('.js-booking-started_at-field');
  const $conferenceTypeContainer = $('.js-conference-type');
  const $chargedPrice = $('.js-charged-price');
  const $price = $('.js-price');
  const $voucherToggle = $('.js-voucher-toggle');
  const $voucherField = $('.js-voucher-field');
  const $voucherInput = $('.js-voucher-input');
  const $voucherClear = $('.js-voucher-clear');
  const $voucherInfoContainer = $('.js-voucher-submit-info');
  const $bookingForm = $('.js-booking-form');
  const $hourAlert = $('.js-hour-alert');

  let validVoucher = false;

  const handleDateSelection = (e) => {
    e.preventDefault();

    const $dateContainer = $(e.currentTarget);
    const $dateLink = $dateContainer.find('a');

    $calendarContainer.find('.js-bookable-date').removeClass('active');
    $dateContainer.addClass('active');

    $dateField.val($dateLink.data('date'));
    $hourField.val('');
    $hourAlert.addClass('d-none');

    $.get($dateLink.data('url'))
      .done((response) => $('.js-hour-availabilities-container').html(response));
  };

  const handleHourSelection = (e) => {
    const $hourBtn = $(e.currentTarget);
    $hoursContainer.find('.js-hour-btn').removeClass('active');
    $hourBtn.addClass('active');

    $hourAlert.addClass('d-none');
    $hourField.val($hourBtn.data('value'));
  };

  const handleConferenceTypeChange = () => {
    if (validVoucher) {
      voucherInputUpdate();
    } else {
      showPrices($conferenceTypeContainer.find('input:checked').data('price'));
    }
  };

  const showPrices = (chargedPrice, price = null) => {
    if((window.location.hostname === 'localhost' || window.location.hostname === 'demo.melapus.com') && localStorage.getItem('isGenerali')) {
      price = chargedPrice;
      chargedPrice = (parseInt(chargedPrice) * 0.90) + ' €';
      if(window.location.pathname.includes("ashmakopoylos-panagiwths")) {
        chargedPrice = '30 €';
      }
      $('.price-info-currency.js-price').css({'text-decoration': 'line-through'})
      $('.voucher').hide();
      $('.voucher').next('hr').hide();
    }
    $chargedPrice.html(chargedPrice);
    $price.html(price);
  };

  const voucherToggle = (e) => {
    e.preventDefault();

    $voucherField.toggle();
  };

  const voucherClear = (e) => {
    e.preventDefault();

    validVoucher = false;
    $voucherInfoContainer.css('display', 'none');
    showPrices($conferenceTypeContainer.find('input:checked').data('price'));
    voucherInputStyle();
    $voucherInput.val('');
  };

  const voucherInputUpdate = (e) => {
    const code = $voucherInput.val();

    voucherInputStyle('danger');
    $voucherInfoContainer.css('display', 'flex');

    if (code.length < 5) {
      validVoucher = false;
      showPrices($conferenceTypeContainer.find('input:checked').data('price'));
      return;
    }

    $.get('/bookings/voucher_check', {
      voucher_code: code,
      therapist_id: therapistID,
      conference_type: $conferenceTypeContainer.find('input:checked').data('type')
    }).done((response) => {
      validVoucher = true;
      voucherInputStyle('success');
      voucherInfo('success', response.message);
      showPrices(response.charged_price, response.price);
    }).fail(({ responseJSON: response }) => {
      validVoucher = false;
      showPrices($conferenceTypeContainer.find('input:checked').data('price'));
      voucherInputStyle('danger');
      voucherInfo('danger', response.message);
    });
  };

  const voucherInputStyle = (style) => {
    if (style === 'danger') {
      $voucherInfoContainer.addClass('voucher-danger').removeClass('voucher-success');
    } else if (style === 'success') {
      $voucherInfoContainer.removeClass('voucher-danger').addClass('voucher-success');
    } else {
      $voucherInfoContainer.removeClass('voucher-danger').removeClass('voucher-success');
    }
  };

  const voucherInfo = (style, message) => {
    const iconName = style === 'danger' ? 'info' : 'success';
    const icon = `<i class="meli meli-${iconName}"></i>`;
    const msg = `<span class="arrow-left"></span><span class="voucher-submit-message">${message}</span>`;
    $voucherInfoContainer.addClass(`voucher-${style}`);
    $voucherInfoContainer.html(`${icon}${msg}`);
  };

  const showHideMobileCols = () => {
    $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      if ($('#nav-home-tab').hasClass('active')) {
        $('.js-card').removeClass('d-none d-lg-block');
      } else if ($('#nav-availability-tab').hasClass('active')) {
        $('.js-card').addClass('d-none d-lg-block');
      }
    });
  };

  const checkRequiredFields = (e) => {
    const headerMenuHeight = 130;

    if ($hourField.val() === '') {
      $hourAlert.removeClass('d-none');
      $('body,html').animate({
        scrollTop: ($hourAlert.offset().top - headerMenuHeight)
      }, 500);
      return false;
    }

    return true;
  };

  $('.js-book-now-show-tab').on('click', () => $('#nav-availability-tab').click());
  $('.js-calendar-container').on('click', '.js-bookable-date', handleDateSelection);
  $('.js-hour-availabilities-container').on('click', '.js-hour-btn', handleHourSelection);
  $('.js-conference-type').on('click', 'input', handleConferenceTypeChange);
  $voucherToggle.on('click', voucherToggle);
  $voucherClear.on('click', voucherClear);
  $voucherInput.on('input', debounce(voucherInputUpdate, 250));
  $bookingForm.on('submit', checkRequiredFields);

  stickyNavTabs('#nav-tab', '.nav-link');
  showPrices($conferenceTypeContainer.find('input:checked').data('price'));
  showHideMobileCols();
};
